<template>
	<div class="erco-group-options">
		<label class="label text-muted" v-if="label">
			{{ label }}
		</label>
		<b-button-group class="option-group">
			<b-button class="option"
			          v-for="(option, index) in options"
			          :key="index"
			          :size="size"
			          :variant="option.active ? 'primary': ''"
			          @click="handleOptionClick(option)">
				{{ option.text }}
			</b-button>
		</b-button-group>
	</div>
</template>
<script>
export default {
	name: 'ErcoOptionsGroupMolecule',

	props: {
		label: {
			type: String,
			default: '',
		},
		size: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
			default: () => [],
		},
	},

	methods: {
		handleOptionClick(option) {
			this.options.forEach(propOption =>
				(propOption.active = (propOption.value === option.value)));
			this.$emit('click', option);
		},
	},
};
</script>

<style lang="scss">

	.erco-group-options {
		& > .label {
			margin: 0;
		}

		& > .option-group {
			display: block;
			margin-top: 0.4rem;

			& > .option {
				width: 2.3rem;
				height: 2.3rem;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoOptionsGroup.vue?764d576b